var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"website-external-wrapper"},[_c('div',{staticClass:"full-area padded vertically-centered"},[(_vm.canRender)?_c('SensataSplash'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }